import { address as mezoMainnetAddress } from "@mezo-org/mezod-contracts/deployments/mainnet/mcbBTC.json"
import { address as mezoTestnetAddress } from "@mezo-org/mezod-contracts/deployments/testnet/mcbBTC.json"
import { Address } from "viem"

import artifacts from "#/shared/utils/artifacts"

export default artifacts.getBridgeableERC20TokenArtifact({
  mainnetAddress: "0xcbB7C0000aB88B473b1f5aFd9ef808440eed33Bf",
  testnetAddress: "0x50ea58658f2139766Bc80694f30005413997E743",
  mezoTestnetAddress: mezoTestnetAddress as Address,
  mezoMainnetAddress: mezoMainnetAddress as Address,
})
